import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="scroll"
export default class extends Controller {
  connect() {
    this.timeout = null;
    this.isScrolling = false;

    setTimeout(() => {
      this.element.classList.remove("translate-y-full");
      this.element.classList.add("translate-y-0");
    }, 1500);

    window.addEventListener("scroll", () => {
      if (!this.isScrolling) {
        window.requestAnimationFrame(this.handleScroll.bind(this));
      }
      this.isScrolling = true;
    });
  }

  handleScroll() {
    clearTimeout(this.timeout);

    const widget = this.element;

    widget.classList.add("translate-y-full");
    widget.classList.remove("translate-y-0");

    this.isScrolling = false;

    this.timeout = setTimeout(() => {
      widget.classList.add("translate-y-0");
      widget.classList.remove("translate-y-full");
    }, 300);
  }
}
